import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";
/* This code is needed to properly load the images in the Leaflet CSS */
delete (Icon as any).Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.config.productionTip = false

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
